
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 65 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.545 1c-1.719.776-3.19 2.153-4.213 3.944C1.31 6.734.787 8.849.834 11c-.047 2.15.476 4.266 1.498 6.056 1.023 1.79 2.494 3.168 4.213 3.944","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('rect',{attrs:{"x":"11.045","y":"5.5","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M32.545 21V1","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}}),_c('rect',{attrs:{"x":"39.045","y":"5.5","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M58.545 1c1.72.776 3.191 2.153 4.214 3.944 1.022 1.79 1.545 3.905 1.498 6.056.047 2.15-.476 4.266-1.498 6.056-1.023 1.79-2.494 3.168-4.214 3.944","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    